import TODO from "./TODO.js";
import {U,L,PERSISTENCE,UTIL} from "./util.js";
import each from 'async-es/each';
import series from 'async-es/series';
import parallel from 'async-es/parallel';
import {
 onMicSelect,onCameraSelect,
 arrange_elements,
 sendTextMessage,cancelSettings,applySettings,
 openTextChatArea,openSettings,
 start_text_animation,GUIUTIL,open_stats,
 onchange_bandwdith,openqualitytype,onautoreschange,
 onactivereschange
} from "./guiutil.js";
import {get_configured_media,make_media_config,list_media_devices,CAMERA,SCREEN,MEDIA} from "./mediautil.js";
import {C2GSOCKET} from "./c2gsock.js";
import {PEER} from './peer.js';
import {STATS} from './stats.js';
import {RESOLUTION,FRAMERATE,BANDWIDTH} from './sender.js';
import {default as STRINGS,set_lang} from './strings';

function resolution(w,h,f) {
 w=+w,h=+h,f=+f;
 if(U.browser.name==='Firefox') f=30;
 return {
  width: { max: w, ideal: w}, height: { max: h, ideal: h },
  advanced: [
   { width: w, height: h },
   {aspectRatio: w/h }
  ],
  frameRate: { max: f, min: f, ideal:f}
 };
}

export function get_bandwidth() {
 const tab=PERSISTENCE.get("sel_tab",'btn_quality_auto');
 var cnf;
 if(tab==="btn_quality_auto") {//automatic
  const type=CAMERA.auto_resolution_map[PERSISTENCE.get("sel_auto_res",'1')];//default 1: medium
  cnf=CAMERA.auto_settings[type].bw;
 }
 else {
  const pd=PERSISTENCE.get({maxdl:BANDWIDTH.max_download,maxul:BANDWIDTH.max_upload});
  cnf={ dl: +pd.maxdl, ul: +pd.maxul };
 }
 return cnf;
}
export function get_resolution(type) {
 if(type!=="active") return L.error("What are you looking for? unsupported type");
 const tab=PERSISTENCE.get("sel_tab","btn_quality_auto");
 if(tab==="btn_quality_auto") {//automatic
  let res=PERSISTENCE.get("sel_auto_res","1");//default 1: medium
  var rtype=CAMERA.auto_resolution_map[res];
  let r=CAMERA.auto_settings[rtype][type].res;
  return {
   width: CAMERA.tests[r].width,
   height: CAMERA.tests[r].height,
   fr:CAMERA.auto_settings[rtype][type].fps
  };
 }
 
 const cnf=CAMERA.tests[PERSISTENCE.get(`${type}_res`,"QQVGA")];
 cnf.fr=PERSISTENCE.get(`${type}_fr`,1);
 return cnf;
}

export function get_active_video_resolution() {
 var cnf=get_resolution('active');
 return resolution(cnf.width,cnf.height,cnf.fr);
}

function getIpFromPeer(uid) {
 const pc=Object.values(PEER.connections).find(pc=>pc.id===uid);
 return pc&&pc.ip||'unknown ip';
}
export function getpeerconnection(id) {
 if (PEER.connections[id]) 
  return PEER.connections[id];
 const pc = new window.XPeerConnection(
  {
   'iceServers': [
    {'urls': 'stun:stun.l.google.com:19302'},
    {
     urls: 'turn:numb.viagenie.ca',
     credential: 'muazkh',
     username: 'webrtc@live.com'
    }
   ],
   sdpSemantics:'unified-plan'
  }
 );
 pc.local_stream=MEDIA.localstream;
 MEDIA.localstream&&MEDIA.localstream.getTracks().forEach((t)=>{
  pc[`${t.kind}sender`]=pc.addTrack(t, MEDIA.localstream);
 });
 pc.onicecandidate = (evnt)=>{
  C2GSOCKET.c2gsocket.msg({to:{user:id},type:'video-ice'},{ice:evnt.candidate});
 };
 pc.onnegotiationneeded = ()=>{
  if(pc.is_under_renegotiation) return;
  L.trace(`${pc.name}: onnegotiationneeded Fired`);
  makeoffer({uid:pc.id,name:pc.name});
 };
 pc.onicegatheringstatechange = ()=>{
  let state=pc.iceGatheringState;
  //L.trace({pc},`${pc.name}: ice gathering state changed to: ${state}`);
  switch(state) {
   case "new":
   case "complete":
    if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
   break;
   case "gathering":
    L. info(`Finding route to connect: ${pc.name}`);
   break;
  }
 };
 //pc.onconnectionstatechange = ()=>{
  //let state=pc.connectionState;
  //L.trace({pc},`${pc.name}: connection state changed to: ${state}`);
 //};
 pc.onsignalingstatechange= ()=>{
  let state=pc.signalingState || pc.readyState;
  //L.trace({pc},`${pc.name}: signal state changed to: ${state}`);
  if(state==='stable')
   pc.is_under_renegotiation=false;
  if(state==='closed') {
   if(pc.iceConnectionState==='connected'
     ||pc.iceConnectionState==='completed') return pc.restartIce();
   L.trace(`${pc.name}: Disconnected.`);
   if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
   $(`#status_${pc.id}`).hide();
   GUIUTIL.notify({
    uid: pc.id,
    text: U.fmt(STRINGS.notify_user_left, { "name": pc.name }),
    timeout: 5000});
  }
 };
 pc.oniceconnectionstatechange = ()=>{
  const state=pc.iceConnectionState;
  L.trace({pc},`${pc.name}: Ice connection state changed to: ${state}`);
  switch(state) {
   case 'connected':
   case 'completed':
    $(`#status_${pc.id}`).hide();
    if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
    if(!pc.isconnected) {
     setTimeout(()=>{
      BANDWIDTH.update_peers_bandwidth((e)=>e&&L.error(e));
     },2000);
     L.info({name: pc.name,IP: pc.ip, room: TODO.roomId, yourid: TODO.selfId},'You joined the room');
     got_remote_stream(pc.id,pc.remote_stream);
    }
    pc.isconnected=true;
   break;
   case 'closed':
   case 'failed':
    if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
    $(`#status_${pc.id}`).show();
    $(`#status_${pc.id}`).html('Connecting');
    pc.restartIce();
    C2GSOCKET.c2gsocket.msg({to:{user:pc.id},type:'peer.reconnect'});
    L.error({name: pc.name},`Ice connection failed - trying to restart ice`);
   break;
   case 'disconnected':
    $(`#status_${pc.id}`).show();
    $(`#status_${pc.id}`).html('Connecting');
    if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
    if(pc.initiator) pc.ice_restart_timer=setTimeout(function(){
     if(pc.iceConnectionState==='connected'
     ||pc.iceConnectionState==='completed') {
      $(`#status_${pc.id}`).hide();
      if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
      return;
     }
     $(`#status_${pc.id}`).show();
     $(`#status_${pc.id}`).html('Connecting');
     pc.restartIce();
     C2GSOCKET.c2gsocket.msg({to:{user:pc.id},type: 'peer.reconnect'});
    },8000);
    break;
   case 'checking':
    $(`#status_${pc.id}`).show();
    $(`#status_${pc.id}`).html('Connecting');
    if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
    if(!pc.initiator) return;
    pc.ice_restart_timer=setTimeout(function(){
     $(`#status_${pc.id}`).show();
     $(`#status_${pc.id}`).html('Connecting');
     L.trace(`Ice connection *state:checking* for long... so restarting ice with : ${pc.name}`);
     pc.restartIce();
     C2GSOCKET.c2gsocket.msg({to:{user:pc.id},type:'peer.reconnect'});
    },15000);
  }
 };
 /*pc.onaddstream = function (evnt) { 
  got_remote_stream(id,evnt.stream);
 };*/
 pc.ontrack=(e)=>{
  L.trace({e,pc,track:e.track},`${pc.name}: Received track ${e.track.kind} muted: ${e.track.muted}`);
  //if(!pc.remote_stream) pc.remote_stream={};
  //if(e.track.kind==='audio') pc.remote_stream.audio=new MediaStream([e.track]);
  //else if(e.track.kind==='video') pc.remote_stream.video=new MediaStream([e.track]);
  //else L.error('Hurray! , There is a new type of track');
  pc.remote_stream=e.streams[0];
  var velm=document.getElementById(`${pc.id}V`);
  if(velm)
   velm.srcObject=e.streams[0];
  e.track.onunmute = ()=>{
   //L.debug(`${pc.name}: track unmute event ${e.track.kind} muted: ${e.track.muted}`);
   //if(elm) elm.play();
  };
 };
 pc.onremovestream = (evnt)=>{
  lost_remote_stream(id,evnt.stream);
 };
 pc.data_channel=pc.createDataChannel("text_chat",{maxRetransmits:3});
 pc.data_channel.onopen= ()=>pc.data_channel.open=true;
 pc.data_channel.onclose= ()=>pc.data_channel.open=false;
 pc.ondatachannel= (evt)=>{
  evt.uid=pc.id;
  got_datachannel(evt);
 };
 pc.id=id;
 pc.is_under_renegotiation=true;
 pc.ice_candidate_list=[];
 PEER.connections[id] = pc;
 return pc;
}

export function makeoffer(pp) {
 var pc = getpeerconnection(pp.uid);
 pc.is_under_renegotiation=true;
 if(pp.un) pc.name=pp.un;
 pc.initiator=TODO.self_name;
 PEER.makeoffer(Object.assign({pc: pc},pp.restart&&{restart:true}),function(e,sdp) {
  if(e) return L.error({name: pc.name, err:e},`Failed to create offer`);
  const mdl=get_bandwidth().dl;
  const d={
   sdp:sdp,
   muteInfo: {audio: MEDIA.muteinfo.audio, video: MEDIA.muteinfo.video, hand: TODO.__isHandRaised},
   name: TODO.self_name,
   mdl: mdl
  };
  L.info({data: d},`You are sending offer to ${pc.name}`);
  C2GSOCKET.c2gsocket.msg({to:{user:pp.uid},type:'video-offer'},d);
 });
}

function got_datachannel(event) {
 event.channel.onmessage=function(evt){
  var name=getpeerconnection(event.uid).name;
  var msg = U.decorate_text(evt.data);
  var control = '<div class="chat_bubble" style="width:100%">' +
                    '<div class="macro">' +
                        '<div class="text text-l">' +
                        '<div class="head-text">'+ (name?(name+""):"unknown") +'&nbsp;<small class="time-text">'+UTIL.getTimestamp()+'</small></div>' +
                         '<div class="msg-text">'+msg+'</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';
  $("#chat_history").append(control);
  $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight);
  if($("#sidebar").css('marginRight')=="-250px") {
   $("#btn_text_chat").addClass("glow");
   $("#btn_more").addClass("glow");
  }
 };
}

/* returns {room:,uid:} */
var joinRoom=async function (r,cb) {
 try {
  if(TODO.connected) throw new Error('connected already?');
  const rv = await C2GSOCKET.c2gsocket.join({room:r,username:TODO.self_name});
  cb(null,{room:rv.room,uid:rv.selfid});
 }catch(e) {
  L.error(e);
  cb(e);
 }
};
function createRoom() {
 var name=$('#txt_user_name_ui').val();
 if(!name) {
  $('#txt_user_name_ui').removeClass('shakeit');
  setTimeout(function(){
   $('#txt_user_name_ui').addClass('shakeit');
   $('#txt_user_name_ui').focus();
  },50);
  return;
 }
 var room_name=$('#txt_room_name').val();
 if(!room_name) {
  $('#txt_room_name').removeClass('shakeit');
  setTimeout(function(){
   $('#txt_room_name').addClass('shakeit');
   $('#txt_room_name').focus();
  },50);
  return;
 }
 TODO.self_name=name;
 PERSISTENCE.put("user", name);
 createNewRoom(room_name);
 $("#btn_self_name").html(name);
 $("#btn_self_name").css('display',"block");
 U.REPORT.user({username: name});
}

function initialize_tooltips() {
 Object.keys(TODO.tips).forEach(k=>$(`#${k}`).attr('title', STRINGS[TODO.tips[k][0]]).tooltip('fixTitle'));
 Object.keys(TODO.tips_bottom).forEach(k=>$(`#${k}`).attr('data-original-title', STRINGS[TODO.tips_bottom[k][0]]).tooltip({ placement: 'bottom' }));
}

function initialize_emos() {
   for(var i in U.emos) {
    var item = $("<div/>").
     attr("class", "emoji").
     attr("data", i).
     html(U.emos[i].icon);
    $("#wtg-emojis").append(item);
   }
   $(".emoji").click(function() {
    const i = +$(this).attr("data");
    var $txt = $("#txt_chat_message");
    var caretPos = $txt[0].selectionStart;
    var textAreaTxt = $txt.val();
    var txtToAdd = U.emos[i].text;
    $txt.val(textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos)).focus();
   });
}

function initialize_self_video(stream) {
 var v_p=document.createElement('div');
 v_p.className="wrap";
 v_p.id=`selfVP`;
 var video_elm=document.createElement('video');
 video_elm.id=`selfV`;
 video_elm.autoplay = true;
 video_elm.playsinline = true;
 video_elm.muted = true;
 video_elm.className="localVideo wtg-flip";
 video_elm.style.objectFit = "cover";
 video_elm.style.objectPosition = "center center";
 v_p.appendChild(video_elm);
 if(stream) video_elm.srcObject=stream;
 if(MEDIA.muteinfo.video) video_elm.style.display='none';
 
 var stats_container=document.createElement('div');
 stats_container.className=`statscontainer`;
 if(STATS.is_on) stats_container.style.display="block";

 var dl=document.createElement('div');
 dl.className="statitem";
 dl.id=`selfbandwidthdownload`;

 var ul=document.createElement('span');
 ul.className="statitem";
 ul.id=`selfbandwidthupload`;

 var br=document.createElement('div');
 br.className="statitem";
 br.id=`selfbytesrecv`;

 var bs=document.createElement('div');
 bs.className="statitem";
 bs.id=`selfbytessent`;

 var pl=document.createElement('div');
 pl.className="statitem";
 pl.id=`selfspl`;

 stats_container.appendChild(dl);
 stats_container.appendChild(ul);
 stats_container.appendChild(br);
 stats_container.appendChild(bs);
 stats_container.appendChild(pl);
 v_p.appendChild(stats_container);

 var name=document.createElement('span');
 name.className="participant_name";
 name.id="username_self";
 name.innerText=STRINGS.self_video_name;
 name.style.width="100%";
 v_p.appendChild(name);

 var media_indicator_audio=document.createElement('div');
 media_indicator_audio.align="center";
 media_indicator_audio.className="media_indicator_audio";
 var am=document.createElement('div');
 am.innerText="mic_off";
 am.className="material-icons md-shadow wtg-mute-indicator";
 am.id="speakericon_self";
 am.style.display=(MEDIA.muteinfo.audio)?"block":"none";

 var media_indicator_video=document.createElement('div');
 media_indicator_video.align="center";
 media_indicator_video.className="media_indicator_video";
 var vm=document.createElement('div');
 vm.className="material-icons md-shadow wtg-mute-indicator";
 vm.id="videomuteicon_self";
 vm.innerText="videocam_off";
 vm.style.display=(MEDIA.muteinfo.video)?"block":"none";

 var raise_hand_indicator=document.createElement('div');
 raise_hand_indicator.align="center";
 raise_hand_indicator.className="raise_hand_indicator_parent";
 var rh=document.createElement('div');
 rh.className="material-icons md-shadow wtg-hand-indicator wtg-flip";
 rh.innerText="pan_tool";
 rh.id="handicon_self";
 rh.style.display=(TODO.__isHandRaised)?"block":"none";

 media_indicator_video.appendChild(vm);
 media_indicator_audio.appendChild(am);
 raise_hand_indicator.appendChild(rh);
 v_p.appendChild(media_indicator_video);
 v_p.appendChild(media_indicator_audio);
 v_p.appendChild(raise_hand_indicator);

 document.getElementById('participants_container').appendChild(v_p);
}
async function connect_me(room) {
 try {
  const participants = C2GSOCKET.c2gsocket.participants({room:room});
  if(participants.length>6&&!(MEDIA.muteinfo.video&&MEDIA.muteinfo.audio)){
   mute_localstream();
   GUIUTIL.notify({
    uid:"Big room",
    text: STRINGS.notify_more_participants,
    timeout: 5000});
  }
 }catch(e) {
  L.error(e);
 }
}
function createNewRoom(room_name) {
 GUIUTIL.show_screen('loadingScreen');
 joinRoom(room_name,function(err,details) {
  if(err)  {
   L.error({err: err},"Failed to join the room");
   GUIUTIL.alert('error',err);
   GUIUTIL.show_screen('welcomeScreen');
   return;
  }
  TODO.roomId = details.room;
  TODO.selfId = details.uid;
  TODO.connected=true;
  connect_me(room_name);
  const status = U.fmt(STRINGS.status_in_room, { "room": room_name });
  $('#room_details_container').html(status + "<SUP><span class='material-icons wtg-sup-button wtg-red'>share</span></SUP>");
 });
 GUIUTIL.show_screen('mainScreen');
 initialize_tooltips();
 initialize_emos();
}
/*function add_track(type,track,cb) {
 each(Object.values(PEER.connections),(pc,cb)=>{
  const sender=pc[`${type}sender`];
  if(sender) sender.replaceTrack(track).then(()=>(L.trace('Track replaced'),cb())).catch(ex=>(L.error(ex),cb()));
  else if(track){
   pc[`${type}sender`]=pc.addTrack(track, pc.local_stream);
   cb();
  }
  else L.error('Something went wrong while adding track');
 },cb);
}
function switch_track(type,bReplace,rTrack,cb) {
 if(bReplace){
  add_track(type,null,(e)=>{
   if(e) return L.error(e),cb(e);
   if(type==='video') TODO.__local_video_elm.style.display='none';
   MEDIA.localstream.getTracks().forEach(t=>(t.kind===type)&&t.stop());
   cb();
  });
 }
 else {
  if(!rTrack) {
   const cnf=Object.assign({},
    (type==='audio')&&{audio:true},
    (type==='video')&&{video:get_inactive_video_resolution_based_on_peers()}
   );
   get_configured_media(cnf,(e,s)=>{
    if(e) return L.error(e),cb(e);
    var track=(type==='video')?s.getVideoTracks()[0]:s.getAudioTracks()[0];
    if(!track) return L.error('Something went wrong while getting track',type),cb('No track');
    add_track(type,track,(e)=>{
     if(e) return L.error(e),cb(e);
     MEDIA.localstream.getTracks().forEach(t=>(t.kind===type)&&MEDIA.localstream.removeTrack(t));
     MEDIA.localstream.addTrack(track);
     if(type==='video') {
      TODO.__local_video_elm.srcObject=MEDIA.localstream;
      TODO.__local_video_elm.style.display='block';
     }
     cb();
    });
   });
  }
  else {
   add_track(type,rTrack,(e)=>{
    if(e) return L.error(e),cb(e);
    if(type==='video')
    TODO.__local_video_elm.style.display='block';
    cb();
   });
  }
 }
}*/
function on_swap_camera() {
 list_media_devices((e,dl)=>{
  if(e) return L.error('Error while list devices');
  let video_devices=dl.videoinput;
  if(video_devices&&Object.keys(video_devices).length>1) {
   const mode=(CAMERA.facingMode==='user'?'environment':'user');
   let ovt=MEDIA.localstream.getVideoTracks();
   ovt=ovt.length&&ovt[0];
   if(ovt) {
    MEDIA.localstream.removeTrack(ovt);
    ovt.stop();
   }
   get_configured_media({video:{facingMode: mode}},(e,s)=>{
    if(e) return L.error(e);
    let nvt=s.getVideoTracks();
    nvt=nvt.length&&nvt[0];
    if(!nvt) return L.error('Could not get video track.');
    CAMERA.facingMode=mode;
    MEDIA.localstream.addTrack(nvt);
    Object.values(PEER.connections).forEach(pc=>pc.videosender.replaceTrack(nvt));
    $("#btn_swap_camera").toggleClass("wtg-green");
    $("#btn_swap_camera").toggleClass("wtg-red");
    $("#selfV").toggleClass("wtg-flip");
   });
  }
  else L.error(`No other camera found to switch`);
 });
}
function on_gallery_view() {
 TODO.gallery = !TODO.gallery;
 $("#btn_gallery_view").toggleClass("wtg-green");
 $("#btn_gallery_view").toggleClass("wtg-red");
 arrange_elements();
 let tooltip = STRINGS[TODO.tips.btn_gallery_view[+TODO.gallery]];
 $("#btn_gallery_view").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
}
function on_leave_room() {
 var cnf=confirm(STRINGS.leave_room_confirm);
 if(cnf) window.location.href='https://www.wenewa.com/';
}
function on_language() {
 $("#language-list").toggleClass("wtg-show");
 $("#language-list").toggleClass("wtg-hide");
}
function on_lang_change() {
 on_language();
 PERSISTENCE.put("lang",$(this).attr("value"));
 apply_strings();
 initialize_tooltips();
 const status = U.fmt(STRINGS.status_in_room, { "room": TODO.roomId });
 $('#room_details_container').html(status + "<SUP><span class='material-icons wtg-sup-button wtg-red'>share</span></SUP>");
 $("#username_self").text(STRINGS.self_video_name);
}
//var muting_in_progress=false;
function switchingLocalAudio() {
 var ats=MEDIA.localstream.getAudioTracks();
 if(!ats.length) return alert('No audio to mute?');
 ats[0].enabled=MEDIA.muteinfo.audio;
 MEDIA.muteinfo.audio=!MEDIA.muteinfo.audio;
 C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'audio'},{muted: MEDIA.muteinfo.audio});
 $("#mute_local_audio").text(MEDIA.muteinfo.audio?"mic_off":"mic");
 $("#mute_local_audio").toggleClass("wtg-green");
 $("#mute_local_audio").toggleClass("wtg-red");
 let tooltip = STRINGS[TODO.tips.mute_local_audio[+MEDIA.muteinfo.audio]];
 $("#mute_local_audio").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
 $("#speakericon_self").css("display", (MEDIA.muteinfo.audio)?"block":"none");
 /*if(muting_in_progress) return L.error('In progress');
 muting_in_progress=true;
 switch_track('audio',!MEDIA.muteinfo.audio,null,function(e){
  muting_in_progress=false;
  if(e)
   return GUIUTIL.alert('error',e.message);
  MEDIA.muteinfo.audio=!MEDIA.muteinfo.audio;
  C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'audio'},{muted: MEDIA.muteinfo.audio});
  $("#mute_local_audio").toggleClass("unmute_local_audio");
  let tooltip = (MEDIA.muteinfo.audio)?"unmute":"mute";
  $("#mute_local_audio").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
 });*/
}
var muteinprogress=false;
function switchingLocalVideo() {
 if(muteinprogress) return L.error('Muting in progress');
 muteinprogress=true;
 var localtrack=MEDIA.localstream.getVideoTracks();
 if(!localtrack.length) return alert('No video to mute?');
 localtrack=localtrack[0];
 if(!MEDIA.muteinfo.video) {
  var dummy=MEDIA.dummy.video();
  MEDIA.localstream.removeTrack(localtrack);
  MEDIA.localstream.addTrack(dummy);
  each(Object.values(PEER.connections),(pc,cb)=>{
   if(!pc.videosender) return cb();
   pc.videosender.replaceTrack(dummy).then(cb).catch(cb);
  },(e)=>{
   if(e) L.error(e);
   muteinprogress=false;
   localtrack.stop();
  });
 }
 else {
  fillMediaStream({video:true},(e,s)=>{
   if(e) L.error(`Error while adding your video`);
   var vt=s.getVideoTracks()[0];
   if(!vt) return L.error('Something went wrong while adding your video');
   if(localtrack) MEDIA.localstream.removeTrack(localtrack);
   MEDIA.localstream.addTrack(vt);
   each(Object.values(PEER.connections),(pc,cb)=>{
    if(!pc.videosender) return cb();
    pc.videosender.replaceTrack(vt).then(cb).catch(cb);
   },(e)=>{
    if(e) L.error(e);
    muteinprogress=false;
   });
  });
 }
 MEDIA.muteinfo.video=!MEDIA.muteinfo.video;
 C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'video'},{muted: MEDIA.muteinfo.video});
 $("#mute_local_video").text(MEDIA.muteinfo.video?"videocam_off":"videocam");
 $("#mute_local_video").toggleClass("wtg-green");
 $("#mute_local_video").toggleClass("wtg-red");
 let tooltip = STRINGS[TODO.tips.mute_local_video[+MEDIA.muteinfo.video]];
 $("#mute_local_video").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
 $('#selfV').css('display',(MEDIA.muteinfo.video)?"none":"block");
 $("#videomuteicon_self").css("display", (MEDIA.muteinfo.video)?"block":"none");

 /*if(muting_in_progress) return L.error('In progress');
 muting_in_progress=true;
 if(SCREEN.is_on) return alert('Screen sharing is running');
 switch_track('video',!MEDIA.muteinfo.video,null,function(e){
  muting_in_progress=false;
  if(e)
   return GUIUTIL.alert('error',e.message);
  MEDIA.muteinfo.video=!MEDIA.muteinfo.video;
  C2GSOCKET.c2gsocket.msg({to:{room:roomId},type:'video'},{muted: MEDIA.muteinfo.video});
  $("#mute_local_video").toggleClass("unmute_local_video");
  var tooltip = (MEDIA.muteinfo.video)?"video on":"video off";
  $("#mute_local_video").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
 });*/
}

function on_raise_hand() {
 TODO.__isHandRaised=!TODO.__isHandRaised;
 C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'hand'},{raised:TODO.__isHandRaised});
 $("#raise_hand").toggleClass("wtg-green");
 $("#raise_hand").toggleClass("wtg-red");
 let tooltip = STRINGS[TODO.tips.raise_hand[+TODO.__isHandRaised]];
 $("#raise_hand").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
 $("#handicon_self").css("display", (TODO.__isHandRaised)?"block":"none");
}

function fillMediaStream(type,cb) {
 make_media_config(type,(e,mc)=>{
  if(e) return cb(e);
  get_configured_media(mc,function(e,s){
   if(e) {
    L.error(e);
    return GUIUTIL.notify({uid:'media-error',text:e.name,timeout:6000});
   }
   list_media_devices((e,dl)=>{
    if(e) return L.error('Error while list devices');
    if(dl.videoinput&&(Object.keys(dl.videoinput).length>1)) {
     $('#btn_swap_camera').show();
    }
   });
   cb(null,s);
  });
 });
}

function enter_room() {
 var next=(r)=>{
  if(MEDIA.localstream) createRoom();
  else fillMediaStream(r,function(e,s){
   if(e) return L.error({err: e},'Failed to get media stream ');
   MEDIA.localstream=s;
   if(PERSISTENCE.get("sel_auto_res")===3) mute_localstream(s);//3: very low
   initialize_self_video(s);
   createRoom();
  });
 };
 qp(function(e,r){
  if(e) return L.error(e);
  if(r.video) {
   $('#lbl_status').text(STRINGS.status_reading_camera_res);
   $('#status-panel-parent').show();
   CAMERA.test(function(e/*,tests*/){
    $('#status-panel-parent').hide();
    if(e) return L.error(e),GUIUTIL.alert('error', STRINGS.alert_camera_res);
    next(r);
   });  
  }
  else next(r);
 });
}
export function onpeerconnect(pp) {
 L.info({pp}, `${pp.un} is trying to join you`);
 GUIUTIL.notify({
  un: pp.un,
  uid: pp.uid,
  text: U.fmt(STRINGS.notify_user_join, { "name": pp.un }),
  timeout: 5000});
 makeoffer({uid: pp.uid,un: pp.un});
}
export function onpeerdisconnect(pp) {
 $(`#${pp.uid}VP,.wtgnotify-${pp.uid}`).remove();
 const peer = PEER.connections[pp.uid];
 if(peer) {
  if(peer.statistics) dead_peers.add_totals(peer.statistics);
  STATS.stop(pp.uid);//stop stats on peer disconnect
  peer.close();
  delete PEER.connections[pp.uid];
  arrange_elements();
 }
 if(speakers[pp.uid]) delete speakers[pp.uid];//removing from speakers
 $(`#${pp.uid}statsparent`).remove();
}

export function onreceiveoffer(pp) {
 var pc = getpeerconnection(pp.by);
 L.info({
  from: pp.by,
  peerstate:pc.signalingState,
  ip: getIpFromPeer(pp.by),
  mdl: pp.mdl
 },`You received offer from ${pp.name}`);
 pc.muteInfo=pp.muteInfo;
 pc.name=pp.name; /* TODO: we should know the name by now */
 pc.mdl=+pp.mdl;
 PEER.makeanswer({pc: pc, sdp: pp.sdp},function(e,sdp){
  if(e) return L.error({name: pc.name, err:e},`Failed to create answer`);
  const mdl=get_bandwidth().dl;
  const data={
   sdp:sdp,
   muteInfo:{
    audio: MEDIA.muteinfo.audio,
    video: MEDIA.muteinfo.video,
    hand: TODO.__isHandRaised
   },
   name:TODO.self_name,
   mdl: mdl
  };
  L.info({data},`You are sending an answer to ${pp.name}`);
  C2GSOCKET.c2gsocket.msg({to:{user:pp.by},type:'video-answer'},data);
  STATS.start();//start stats on callee
  show_stats();
 });
}
export function onreceiveanswer(pp) {
 var pc = getpeerconnection(pp.by);
 L.info({
  from: pp.by,
  peerstate:pc.signalingState,
  ip: getIpFromPeer(pp.by)
 },`You received answer from ${pp.name}`);
 pc.muteInfo=pp.muteInfo;
 pc.name=pp.name;
 pc.mdl=+pp.mdl;
 //if(pc.signalingState!="have-local-offer" && pc.signalingState!="have-local-pranswer") return;
 PEER.processanswer({pc: pc,sdp: pp.sdp},function(e){
  if(e) return L.error({name:pc.name, pc,err:e}, `Failed to set remote description`);
  $(`#status_${pc.id}`).hide();
  STATS.start();//start stats on caller
  show_stats();
  if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
  pc.ice_restart_timer=setTimeout(function(){
   if(pc.iceConnectionState==='connected'
     ||pc.iceConnectionState==='completed') {
    $(`#status_${pc.id}`).hide();
    if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
    return;
   }
   if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
   $(`#status_${pc.id}`).show();
   $(`#status_${pc.id}`).html('Connecting');
   L.info(`No clue about exchanging Ice... trying to restart ice: ${pc.name}`);
   pc.restartIce();
   C2GSOCKET.c2gsocket.msg({to:{user:pc.id},type:'peer.reconnect'});
  },30000);
 });
}

export function onicecandidate(pp) {
 if(!pp.ice) return;
 const candidate=new window.XIceCandidate(pp.ice);
 const pc=getpeerconnection(pp.by);
 if(candidate.type==='srflx') pc.ip=candidate.address;
 if(!pc||pc.remoteDescription == null)
		return pc.ice_candidate_list.push(pp.ice);
	pc.addIceCandidate(candidate);
}
export function on_screenshare(pp) {
 $(`#${pp.by}V`).css("object-fit", pp.is_on?"contain":"cover");
}
export function on_peer_reconnect(pp) {
 const pc=PEER.connections[pp.by];
 L.info({by:pp.by,peers:Object.values(PEER.connections).map(p=>p.id)},`You are reconnecting to ${pc.name}`);
 if(pc.ice_restart_timer) clearTimeout(pc.ice_restart_timer);
 $(`#status_${pc.id}`).show();
 $(`#status_${pc.id}`).html('Connecting');
}
export function on_mute_audio(pp) {
 const pc=PEER.connections[pp.by];
 if(!pc) return L.error({by:pp.by,peers:Object.values(PEER.connections).map(p=>p.id)},'Audio mute event from unknown user');
 L.trace({pp},`on_mute_audio- ${pc.name}: has ${pp.muted?"muted":"unmuted"} his audio`);
 if(!pc.muteInfo) pc.muteInfo={};
 pc.muteInfo.audio=pp.muted;
 if(pp.muted&&speakers[pc.id]) // removing from speakers
  delete speakers[pc.id];
 $('#speakericon_'+pp.by).css('display',(pp.muted?'block':'none'));
}
export function on_mute_video(pp) {
 const pc=PEER.connections[pp.by];
 if(!pc) return L.error({by:pp.by,peers:Object.values(PEER.connections).map(p=>p.id)},'Video mute event from unknown user');
 L.trace({pp},`on_mute_video- ${pc.name}: has ${pp.muted?"muted":"unmuted"} his video`);
 if(!pc.muteInfo) pc.muteInfo={};
 pc.muteInfo.video=pp.muted;
 $('#videomuteicon_'+pp.by).css('display',pp.muted?'block':'none');
 $('#videomuteicon_'+pp.by).css('display',pp.muted?'block':'none');
 $(`#${pp.by}V`).css('display',pp.muted?"none":"block");
}
export function on_event_raise_hand(pp) {
 const pc=PEER.connections[pp.by];
 if(!pc) return L.error({by:pp.by,peers:Object.values(PEER.connections).map(p=>p.id)},'Raise hand event from unknown user');
 L.trace({pp},`on_event_raise_hand- ${pc.name}: has ${pp.raised?"raised":"dropped"} his hand`);
 if(!pc.muteInfo) pc.muteInfo={};
 pc.muteInfo.hand=pp.raised;
 $('#handicon_'+pp.by).css('display',pp.raised?'block':'none');
}
export function on_dimension(pp) {
 const pc=PEER.connections[pp.by];
 if(!pc) return L.error({by:pp.by,peers:Object.values(PEER.connections).map(p=>p.id)},'Dimension event from unknown user');
 if(pp.to!==TODO.selfId) return;
 L.trace({pp},`on_dimension- ${pc.name}: shows you with dimension ${pp.x} X ${pp.y}`);
 adjust_video_quality(pp.by, pp.x);
}
export function on_bandwidth(pp) {
 var pc=PEER.connections[pp.by];
 if(!pc) return L.error({by:pp.by,peers:Object.values(PEER.connections).map(p=>p.id)},'Bandwidth event from unknown user');
 L.trace({pp},`on_bandwidth- ${pc.name}: has changed the call quality to ${pp.mdl}`);
 pc.mdl = pp.mdl;
 BANDWIDTH.update_peers_bandwidth((e)=>e&&L.error(e));
}
export function on_peername_change(pp) {
 var pc = getpeerconnection(pp.by);
 pc.name=pp.value;
 $("#username_"+pp.by).html(pp.value);
}
function register_element_events() {

 const bchecked=PERSISTENCE.get("speaker_detection");
 $("#chkb_active_participant").prop('checked',!!(bchecked===undefined||bchecked==1));
 
 $('#sidebarCollapse').on('click', function () {
  $('#sidebar').toggleClass('active');
 });
 
 const chatform = $('#form_chat_message').submit(()=>(sendTextMessage(),false));
 $('#txt_chat_message').on("keypress", function(e) {
  if(e.keyCode!=13) return;
  chatform.submit();
  return false;
 });

 $('#details_layer').submit(()=>(enter_room(),false));

 $('#btn_self_name').on('click',function() {
  $("#btn_self_name").css('display','none');
  $("#txt_self_name").css('display','block').val(TODO.self_name).focus();
 });
 
 $('#btn_close_chat').on('click',function() {
  openTextChatArea();
 });

 $('#form_selfbaptize').submit(()=>{
  const $btn = $('#btn_self_name'), $txt=$('#txt_self_name');
  $btn.css('display','block');
  $txt.css('display','none');
  const newname = $txt.val();
  if(newname && newname!=TODO.self_name) {
   PERSISTENCE.put("user",TODO.self_name=newname);
   $btn.text(newname);
   C2GSOCKET.c2gsocket.name(TODO.self_name);
  }
  return false;
 });

 $('#room_details_container').on('click',()=> {
  // TODO: the url construction is funny
  U.copy_to_clipboard(UTIL.get_endpoint() + window.location.pathname+"?rid="+TODO.roomId);
  GUIUTIL.notify({
   uid: "info",
   text: STRINGS.notify_url_copied,
   timeout: 5000});
 });

 let admin_clicks = 0;
 let admin_timer;
 $('#app_title').on('click',()=> {
  if(++admin_clicks>=5) {
   $('#admin-panel-parent').show();
/* TODO: this is not going to work at any reasonable scale
   C2GSOCKET.c2gsocket.get_rooms((list)=> {
    $('#rooms-list-container').empty().append(list.map((room)=>{
     const $rv = $(`
      <div class="room-item">
       <div class="room-left-item"></div>
       <div class="room-middle-item">Participants: ${room.p}</div>
       <div class="room-right-item">( X )</div>
      </div>
     `);
     $('.room-left-item',$rv).text(`Room: ${room.n}`);
     $('.room-right-item',$rv).on('click',()=>{
      C2GSOCKET.c2gsocket.delete_room({room:room.n},(r)=>L.trace({r},'Delete room'));
     });
     return $rv;
    }));
   });
 */
  }
  admin_timer && clearTimeout(admin_timer);
  admin_timer = setTimeout(()=>{admin_clicks=0;admin_timer=undefined},1500);
 });
 $('#admin_closer').on('click',()=>{
  $('#admin-panel-parent').hide();
 });

 $('#btn_quality').click(
   ()=>{
   if($("#wtg-quality-range").is(':hidden')) {
    update_quality_summary();
    $("#wtg-quality-range").val(3-sel_auto_res);
   }
   if($("#wtg-more-actions").is(':visible')) {
    $("#btn_more").toggleClass("wtg-green").toggleClass("wtg-red");
    $("#wtg-more-actions").toggle();
   }
   $("#btn_quality").toggleClass("wtg-green").toggleClass("wtg-red");
   $("#wtg-quality").toggle();
  });
 $(document).on('input', '#wtg-quality-range', function() {
  sel_auto_res = 3-(+$('#wtg-quality-range').val());
  PERSISTENCE.put('sel_auto_res',sel_auto_res);
  update_quality_summary();
  show_stats();
  BANDWIDTH.update_peers_bandwidth((e)=>e&&L.error(e));
  C2GSOCKET.c2gsocket.msg(
   {to:{room:TODO.roomId},type:'bandwidth'},
   {mdl: get_bandwidth().dl});
 });
 $('#mute_local_audio').on('click',switchingLocalAudio);
 $('#mute_local_video').on('click',switchingLocalVideo);
 $('#btn_more').click(()=>{
  if($("#wtg-quality").is(':visible')) {
   $("#btn_quality").toggleClass("wtg-green").toggleClass("wtg-red");
   $("#wtg-quality").toggle();
  }
  $("#wtg-more-actions").toggle();
  $("#btn_more").toggleClass("wtg-green").toggleClass("wtg-red");
 });
 $('#btn_emoji').click(()=>$("#wtg-emojis").toggle());
 $('#raise_hand').on('click',on_raise_hand);
 $('#btn_share_screen').on('click',on_share_screen);
 $('#btn_gallery_view').on('click',on_gallery_view);
 $('#btn_swap_camera').on('click',on_swap_camera);
 $('#btn_leave_room').on('click',on_leave_room);
 $('#btn_language').on('click',on_language);
 $('.wtg-list-item').on('click',on_lang_change);

 $('#btn_settings').on('click',openSettings);
 $('#btn_text_chat').on('click',openTextChatArea);
 $('#btn_apply_settings').on('click',applySettings);
 $('#btn_cancel_settings').on('click',cancelSettings);
 
 $('#btn_stats').on('click',open_stats);

 const $camdd = $('#camera-dropdown').on('change',()=>{
  if($camdd.prop('selectedIndex')) onCameraSelect($camdd.val());
 });
 const $micdd = $('#mic-dropdown').on('change',()=>{
  if($micdd.prop('selectedIndex')) onMicSelect($micdd.val());
 });
 /*
 const $spkdd = $('#speaker-dropdown').on('change',()=>{
  if($spkdd.prop('selectedIndex')) onSpeaerSelect($spkdd.val());
 });
 */
 const $bwdd = $('#dd_bandwidth').on('change',()=>{
  if($bwdd.prop('selectedIndex')) onchange_bandwdith($bwdd.val());
 });
 $(".tablinks").on('click',(e)=>{
  openqualitytype(e.target.id);
 });
 $("#range_auto_quality").on("change",onautoreschange);

 
 const $activeresdd = $('#active-sp-dropdown').on('change',()=>{
  if($activeresdd.prop('selectedIndex')) onactivereschange($activeresdd.val());
 });
}

function update_quality_summary() {
 const status = U.fmt(STRINGS.consumption_summary,
                      { "data": ["9GB", "4.5GB", "900MB", "45MB"][sel_auto_res]});
 $("#wtg-quality-summary").html(status);
}

function qp(cb){
 MEDIA.query_permissions(function(e,r){
  if(!(r.audio&&r.video)) {
   parallel({
    video: function prompt_for_video_permission(cb) {
     navigator.mediaDevices.getUserMedia({video:true})
     .then(s=>{
      s.getTracks().forEach(t=>t.stop());
      cb(null,{res: true});
     }).catch(ex=>cb(null,{res: false,e: ex}));
    },
    audio: function prompt_for_audio_permission(cb) {
     navigator.mediaDevices.getUserMedia({audio:true})
     .then(s=>{
      s.getTracks().forEach(t=>t.stop());
      cb(null,{res: true});
     }).catch(ex=>cb(null,{res: false,e: ex}));
    }
   },(e,r)=>{
    if(e) return L.error({e});
    if(!(r.audio.res||r.video.res))
     return GUIUTIL.alert('error', STRINGS.alert_audio_video_not_accessible);
    if(r.audio.e&&r.audio.e.name) {
     let err=MEDIA.error(r.audio.e.name,"Mic");
     L.error(err);
     GUIUTIL.notify({uid:"initial-audio-error",text:err,timeout:3000});
    }
    if(r.video.e&&r.video.e.name) {
     let err=MEDIA.error(r.video.e.name,"Camera");
     L.error(err);
     GUIUTIL.notify({uid:"initial-video-error",text:err,timeout:3000});
    }
    cb(e,{audio: r.audio.res, video: r.video.res});
   });
  }
  else cb(null,r);
 });
}
function manageelements_visibility() {
 $('#notification-container').css('display','block');
}
function mute_localstream(s) {
 s=s||MEDIA.localstream;
 const vt=s.getVideoTracks();
 if(vt.length&&!MEDIA.muteinfo.video) switchingLocalVideo();
 const at=s.getAudioTracks();
 if(at.length&&!MEDIA.muteinfo.audio) switchingLocalAudio();
}
function apply_strings() {
 //console.log("language from storage: " + PERSISTENCE.get("lang"));
 set_lang(PERSISTENCE.get("lang","en"));
 $(document).attr("title", STRINGS.app_name);
 $("#txt_user_name_ui").attr("placeholder", STRINGS.input_name);
 $("#txt_room_name").attr("placeholder", STRINGS.input_room);
 $("#txt_self_name").attr("placeholder", STRINGS.input_name);
 $("#txt_chat_message").attr("placeholder", STRINGS.input_message);
 update_stats_on_screen({
  "download": 0, "upload": 0,
  "total_bytes_recv": 0, "total_bytes_sent": 0,
  "packets_lost": 0 });
 const elements = {
  "app_title": { "str": "app_name" },
  "secure_head": { "str": "caption_title_secure" },
  "secure_text": { "str": "caption_subtitle_secure" },
  "simple_head": { "str": "caption_title_simple" },
  "simple_text": { "str": "caption_subtitle_simple" },
  "unlimited_head": { "str": "caption_title_unlimited" },
  "unlimited_text": { "str": "caption_subtitle_unlimited" },
  "enter_room": { "str": "enter_room" },
  "product_text": { "str": "product_info", "data": { "product": STRINGS.app_name, "company": STRINGS.company_name} },
  "title_settings": { "str": "title_settings" },
  "title_camera": { "str": "title_camera" },
  "title_mic": { "str": "title_mic" },
  "title_detect_speaker": { "str": "title_detect_speaker" },
  "title_call_quality": { "str": "title_call_quality" },
  "title_quality_high": { "str": "title_quality_high" },
  "title_quality_medium": { "str": "title_quality_medium" },
  "title_quality_low": { "str": "title_quality_low" },
  "title_quality_very_low": { "str": "title_quality_very_low" },
  "title_active_speaker": { "str": "title_active_speaker" },
  "title_fps": { "str": "title_fps" },
  "title_max_bandwidth": { "str": "title_max_bandwidth" },
  "title_download": { "str": "title_download" },
  "title_upload": { "str": "title_upload" },
  "btn_apply": { "str": "btn_apply" },
  "btn_cancel": { "str": "btn_cancel" },
  "title_language": { "str": "title_language" },
  "btn_quality_auto": { "str": "title_basic" },
  "btn_quality_manual": { "str": "title_advanced" },
  "wtg-quality-head": { "str": "consumption_head" }
 };
 for(var elem in elements) {
  $("#"+elem).html(U.fmt(STRINGS[elements[elem].str],
                         elements[elem].data?elements[elem].data:{}));
 }
}
export function pageReady() {
 if(!U.browser.support.call)
  return GUIUTIL.alert('error', STRINGS.error_webrtc);
 manageelements_visibility();
 register_element_events();

 qp(function(e,r){
  if(e) return L.error(e);
  const room = U.query.get('rid'), user = PERSISTENCE.get('user');
  user && $('#txt_user_name_ui').val(user);
  room && $('#txt_room_name').val(room);

  if(room && user) {
   /* TODO: DOES NOT BELONG HERE */
   if(MEDIA.localstream) createRoom();
   else {
    const sel_res=PERSISTENCE.get("sel_auto_res");
    if(r.video) {
     $('#lbl_status').text(STRINGS.status_reading_camera_res);
     $('#status-panel-parent').show();
     CAMERA.test(function(e/*,tests*/){
      $('#status-panel-parent').hide();
      if(e) return L.error(e),GUIUTIL.alert('error', STRINGS.alert_camera_res);
      fillMediaStream(r,(e,s)=>{
       if(e) return L.error(e),GUIUTIL.alert('error', STRINGS.alert_audio_video_not_accessible);
       MEDIA.localstream=s;
       if(sel_res===3) mute_localstream(s);//3: very low
       initialize_self_video(s);
       createRoom();
      });
     });
    }
    else fillMediaStream(r,(e,s)=>{
     if(e) return L.error(e),GUIUTIL.alert('error', STRINGS.alert_audio_video_not_accessible);
     MEDIA.localstream=s;
     if(sel_res===3) mute_localstream(s);//3: very low
     initialize_self_video(s);
     createRoom();
    });
   }
   /* TODO: DOES NOT BELONG HERE */
  }

  setTimeout(function() {
   GUIUTIL.handle_exit_fullscreen(exit_handler);
   apply_strings();
   start_text_animation();
   GUIUTIL.show_screen('welcomeScreen');
   const $focus = $(user?'#txt_room_name':'#txt_user_name_ui');
   setTimeout($focus.addClass.bind($focus,'shakeit'),300);
  }, 100);
 });
}

var start_time=null;
var cur_speaker=0;
const speakers={};
const bytes2Mbits = 8/1024/1024;
let stats_timeout = undefined;
let speaking_timeout = undefined;
var speaking=false;
var sel_tab=PERSISTENCE.get("sel_tab","btn_quality_auto");
var sel_auto_res=PERSISTENCE.get("sel_auto_res","1");

class stats_accumulator {
 constructor() {
  this.upload = 0;
  this.download = 0;
  this.total_bytes_sent = 0;
  this.total_bytes_recv = 0;
  this.packets_lost = 0;
 }
 add(stats) {
  this.upload += stats.upload;
  this.download += stats.download;
  this.add_totals(stats);
 }
 add_totals(stats) {
  this.total_bytes_sent += stats.total_bytes_sent;
  this.total_bytes_recv += stats.total_bytes_recv;
 }
}
const dead_peers = new stats_accumulator();

function show_stats() {
 if(stats_timeout) clearTimeout(stats_timeout);
 const peers = Object.values(PEER.connections);
 const npeers = peers.length;

 var self_audio_level=0;
 const totals = new stats_accumulator();

 for(const pc of peers) {
  const d=pc.statistics;
  if(!d) continue;

  totals.add(d);

  self_audio_level=d.self_audiolevel||0;
  if(d.audiolevel&&($(".wrap").length>1)&&(d.audiolevel>10)) {
   const ts=new Date();
   const speaker = speakers[d.id]||(speakers[d.id]={id:d.id,from:ts,name:pc.name});
   speaker.to=ts;
   speaker.dur=(speaker.from-speaker.to);
  }

  const upload=`\u2191 ${(d.upload*bytes2Mbits).toFixed(1)} `;
  const download=`\u2193 ${(d.download*bytes2Mbits).toFixed(1)} `;
  const total_sent=`\u2191 ${U.format_size_units(d.total_bytes_sent,1)}`;
  const total_recv=`\u2193 ${U.format_size_units(d.total_bytes_recv,1)}`;

  $(`#${d.id}bandwidthdownload`).text(download);
  $(`#${d.id}bandwidthupload`).text(upload);
  $(`#${d.id}bytesrecv`).text(total_recv);
  $(`#${d.id}bytessent`).text(total_sent);
  $(`#${d.id}spl`).text(`PL: ${d.packets_lost}`);
  $(`#${d.id}rtt`).text(`RTT: ${d.cRTT}`);
  $(`#${d.id}alevel`).text(`AL: ${d.audiolevel.toFixed(2)}`);
 }

 /**Update self video resolution */
 if(self_audio_level>10
    && !MEDIA.muteinfo.video && !SCREEN.is_on
    && npeers>2 ) {
  if(!start_time) start_time=new Date();
  else if((new Date()-start_time)>1000) {
   if(!speaking) {
    L.trace("I'm saying something");
    adjust_framerate(false);
   }
   speaking=true;
  }
  if(speaking_timeout) clearTimeout(speaking_timeout);
  speaking_timeout=setTimeout(function(){
   L.trace("I'm not talking right now");
   speaking=false;
   start_time=null;
   if(!SCREEN.is_on) adjust_framerate(true);
  },5000);
 }

 totals.add_totals(dead_peers);
 update_stats_on_screen(totals);

 /**Update active speaker */
 const ts=new Date();
 Object.keys(speakers).forEach(s=>{
  if((ts-speakers[s].to)>3000) delete speakers[s];
 });
 const temp = Object.entries(speakers).sort((a,b)=>(b[1].dur-a[1].dur));
 var long_speaker = temp.length && temp[0][0];
 if(long_speaker && long_speaker!=cur_speaker) {
  cur_speaker=long_speaker;
  for(const peer of peers) peer.speaker = peer.id==long_speaker;
  arrange_elements();
 }
 show_timer();
 stats_timeout=setTimeout(show_stats,1000);
}

var timer_start = undefined;
function show_timer() {
 if(!timer_start) {
  timer_start = new Date();
  $("#wtg-timer").css('display',"block");
 }
 const p = [0,1].reduce((p)=>(p.o.push(p.i%60),p.i=Math.floor(p.i/60),p),
  {i:Math.floor((+new Date()-timer_start)/1000),o:[]});
 $('#wtg-timer').text(p.o.concat(p.i).map(x=>(''+x).padStart(2,'0')).reverse().join(':'));
}

function update_stats_on_screen(totals) {
 const upload=`\u2191 ${((totals.upload*bytes2Mbits).toFixed(1))} `;
 const download=`\u2193 ${((totals.download*bytes2Mbits)).toFixed(1)} `;
 const total_sent=`\u2191 ${U.format_size_units(totals.total_bytes_sent,1)}`;
 const total_recv=`\u2193 ${U.format_size_units(totals.total_bytes_recv,1)}`;
 $(`#selfbandwidthdownload`).text(download);
 $(`#selfbandwidthupload`).text(upload);
 $(`#selfbytesrecv`).text(total_recv);
 $(`#selfbytessent`).text(total_sent);
 $(`#selfspl`).text(`PL: ${totals.packets_lost}`);
 var quality = "advanced";
 if(sel_tab == "btn_quality_auto") {
  quality = [STRINGS.title_quality_high, STRINGS.title_quality_medium, STRINGS.title_quality_low, STRINGS.title_quality_very_low][sel_auto_res];
 }
 const status = U.fmt(STRINGS.status_quality_stats,
                      { "quality": quality,
                        "total": U.format_size_units(totals.total_bytes_sent+totals.total_bytes_recv,1),
                        "stats": download+upload+total_recv+" "+total_sent+" PL: "+totals.packets_lost
                      });
 $("#tot-stats-panel").html(status);
}

function on_share_screen() {
 if(UTIL.is_mobile()) return GUIUTIL.alert('warn', STRINGS.alert_share_screen_desktop_only);
 if(MEDIA.muteinfo.video) return GUIUTIL.alert('error', STRINGS.alert_share_screen_video_muted);
 if(!Object.keys(PEER.connections).length) {
  GUIUTIL.alert('warn', STRINGS.alert_share_screen_no_participants);
  return;
 }
 var svt=null;
 var lvt=MEDIA.localstream.getVideoTracks();
 lvt=lvt.length&&lvt[0];
 if(!SCREEN.is_on){
  SCREEN.startcapture(function(e,s){
   if(e) return  L.error(e),GUIUTIL.alert('error',e.message);
   SCREEN.stream=s;
   svt=s.getVideoTracks();
   svt=svt.length&&svt[0];
   if(!svt) return L.error("No video track found for screen"),GUIUTIL.alert('error', STRINGS.alert_share_screen_missing);
   // somebody clicked on "Stop sharing"
   svt.onended = function () {
    on_share_screen();
   };
   each(Object.values(PEER.connections),(pc,cb)=>{
    const sender=pc.videosender;
    if(sender) sender.replaceTrack(svt);
    else pc.videosender=pc.addTrack(svt);
    cb();
   },e=>{
    if(e) return L.error({e},`Error while replacing screen track`),GUIUTIL.alert('error',e);
    L.trace(`Screen track sent for all the peers available`);
    $("#btn_share_screen").toggleClass("wtg-green");
    $("#btn_share_screen").toggleClass("wtg-red");
    document.getElementById("btn_share_screen").style.pointerEvents = 'auto';
    SCREEN.is_on=!SCREEN.is_on;
    let tooltip = STRINGS[TODO.tips.btn_share_screen[+SCREEN.is_on]];
    $("#btn_share_screen").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
    C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'screenshare'},{is_on:SCREEN.is_on});
   });
   /*switch_track('video',false,vt,function(e){
    if(e) return GUIUTIL.alert('error',e.message);
    $("#btn_share_screen").toggleClass("un_share_screen");
    document.getElementById("btn_share_screen").style.pointerEvents = 'auto';
    SCREEN.is_on=!SCREEN.is_on;
    let tooltip = (SCREEN.is_on)?"unshare screen":"share screen";
    $("#btn_share_screen").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
    C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'screenshare'},{is_on: SCREEN.is_on});
   });*/
  });
 }
 else {
  each(Object.values(PEER.connections),(pc,cb)=>{
   const sender=pc.videosender;
   if(sender) sender.replaceTrack(lvt||null);
   else pc.videosender=pc.addTrack(lvt||null);
   cb();
  },e=>{
   if(e) return L.error({e},`Error while replacing screen track`),GUIUTIL.alert('error',e);
   L.trace(`Screen track sent for all the peers available`);
   $("#btn_share_screen").toggleClass("wtg-green");
   $("#btn_share_screen").toggleClass("wtg-red");
   SCREEN.is_on=!SCREEN.is_on;
   let tooltip = STRINGS[TODO.tips.btn_share_screen[+SCREEN.is_on]];
   $("#btn_share_screen").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
   C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'screenshare'},{is_on:SCREEN.is_on});
   SCREEN.stopcapturing();
  });

  /*switch_track('video',false,null,function(e){
   if(e) return GUIUTIL.alert('error',e.message);
   $("#btn_share_screen").toggleClass("un_share_screen");
   SCREEN.is_on=!SCREEN.is_on;
   let tooltip = (SCREEN.is_on)?"unshare screen":"share screen";
   $("#btn_share_screen").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
   C2GSOCKET.c2gsocket.msg({to:{room:TODO.roomId},type:'screenshare'},{is_on: SCREEN.is_on});
   SCREEN.stopcapturing();
  });*/
 }
}
function lost_remote_stream(id,stream) {
 L.info("lost remote stream");
 var old_elm=document.getElementById(stream.id);
 if(old_elm)old_elm.remove();
 arrange_elements();
}

var is_in_progress=false;
var active_settings;
function adjust_framerate(islow_res) {
 if(is_in_progress) return;
 is_in_progress=true;
 if(!active_settings) active_settings=get_active_video_resolution();
 series([
  function setframerate(cb) {
   FRAMERATE.set((islow_res?1:active_settings.frameRate.max),(e)=>{
    if(e) L.error(e);
    cb();
   });
  }
 ],(e)=>{
  if(e) L.error(e);
  else L.trace(`adjusting framerate - done`);
  is_in_progress=false;
 });
}
function adjust_video_quality(peer_id, x) {
 if(!active_settings) active_settings=get_active_video_resolution();
 const self_x = active_settings.width.max;
 var fraction = 1.0;
 if(x!=0) fraction = (self_x>x)?(self_x/x):(1.0);
 //console.log("self: " + self_x + ", peer: " + x);
 //console.log("applying scaledown of: " + fraction);
 series([
  function setresolution(cb) {
   RESOLUTION.scaledown(peer_id, fraction,(e)=>{
    if(e) L.error(e);
    cb();
   });
  }
 ],(e)=>{
  if(e) L.error(e);
  else L.trace(`adjusting video quality - done`);
 });
}

async function got_remote_stream(id,stream) {
 const pc=getpeerconnection(id);
 if(!(stream&&stream.getTracks().length)) L.trace(`${pc.name}: No tracks received yet`);
 const make_video_box=()=>{
  L.trace({pc, 
    audio: stream&&stream.getAudioTracks(),
    video: stream&&stream.getVideoTracks()
   },`Got remote stream from ${pc.name}`
  );

  const v_p= $('<div/>').attr("id",`${id}VP`).addClass("wrap");

  /*const video_elm = $('<video />', {
   id: `${id}V`,
   srcObject: stream
  }).attr("playsinline",null).prop({autoplay:true})
  .addClass('participant_video').css('display',(pc.muteInfo&&pc.muteInfo.video)?'none':'block');
  v_p.append(video_elm);
  video_elm.trigger('play');*/ //TODO:: Not working, need to check it later
  const video_elm=document.createElement('video');
  video_elm.id=`${id}V`;
  video_elm.autoplay = true;
  video_elm.setAttribute("playsinline",null);
  video_elm.srcObject = stream;
  video_elm.className="participant_video";
  if(pc.muteInfo&&pc.muteInfo.video) video_elm.style.display="none";
  v_p.append(video_elm);
  

  v_p.append($('<span/>').attr('id',`username_${id}`).addClass('participant_name').text(pc.name));

  const stats_container=$('<div/>').addClass('statscontainer').css('display',STATS.is_on?'block':'none');
  ['bandwidthdownload','bandwidthupload','bytesrecv','bytessent','spl','rtt','alevel'].forEach(eid=>{
   stats_container.append($('<div/>').attr('id',`${id}${eid}`).addClass('statitem'));
  });
  v_p.append(stats_container);

  const status=$('<div/>').attr('id',`status_${id}`).addClass('participant_status')
   .html((!stream||!pc.connectionState!=='connected')?"Connecting":"");
  v_p.append(status);

  const media_indicator_audio=$('<div/>').css('text-align','center').addClass('media_indicator_audio')
   .append($('<div/>').attr('id',`speakericon_${id}`).addClass('material-icons md-shadow wtg-mute-indicator')
    .css('display',(pc.muteInfo&&pc.muteInfo.audio)?"block":"none").text('mic_off'));

  const media_indicator_video=$('<div/>').css('text-align','center').addClass('media_indicator_video')
   .append($('<div/>').attr('id',`videomuteicon_${id}`).addClass('material-icons md-shadow wtg-mute-indicator')
    .css('display',(pc.muteInfo&&pc.muteInfo.video)?"block":"none").text('videocam_off'));

  const raise_hand_indicator=$('<div/>').css('text-align','center').addClass('raise_hand_indicator_parent')
   .append($('<div/>').attr('id',`handicon_${id}`).addClass('material-icons md-shadow wtg-hand-indicator wtg-flip')
    .css('display',(pc.muteInfo&&pc.muteInfo.hand)?"block":"none").text('pan_tool'));

  v_p.append(media_indicator_video);
  v_p.append(media_indicator_audio);
  v_p.append(raise_hand_indicator);
  /*var ac=document.createElement('div');
  ac.style.width="10px";
  ac.style.height="100%";
  var acic=document.createElement('div');
  acic.style.position="relative";
  acic.style.height="100%";
  acic.style.width="100%";
  var aci=document.createElement('div');
  aci.style.position="absolute";
  aci.style.width="100%";
  aci.style.height="0%";
  aci.style.bottom="0%";
  aci.style.backgroundColor="rgba(255,255,255,0.2)";
  aci.className="height-transition";
  aci.style.borderTop="2px solid white";
  aci.style.backgroundImage="-webkit-linear-gradient(bottom,#10FF00 0%,#70FF00 20%,#D0FF00 40%,#FFE000 60%,#FF6000 80%, #FF0000 100%)";
  //am.style.backgroundImage='url("img/audio_mute.png")';
  //am.style.backgroundSize="100% 100%";
  ac.style.position="absolute";
  ac.style.bottom="0px";
  ac.style.left="0px";
  aci.className=id+":level";
  acic.appendChild(aci);
  ac.appendChild(acic);
  v_p.appendChild(ac);*/
  $('#participants_container').append(v_p);
  //ac.style.width=ac.offsetWidth+'px';
  $(video_elm).css('object-fit','cover');
  $(video_elm).css('object-position','center center');
  $(`#${id}VP`).click(function() {
   GUIUTIL.fullscreen(this);
   C2GSOCKET.c2gsocket.event({
    by:TODO.selfId,
    to:+(this.id.replace("VP","")),
    type:'dimension',
    x:$(window).width(),
    y:$(window).height()
   });
  });
 };
 const p = await C2GSOCKET.c2gsocket.participants({room:TODO.roomId});
 var user=p&&p.length&&p.find(x=>x.uid==id);
 if(!(user&&user.un)) return;
 var velm=document.getElementById(`${id}V`);
 if(velm)
  velm.srcObject=stream;
 else {
  make_video_box();
  arrange_elements();
 }
 $("#username_"+id).html(user&&user.un);
}

function exit_handler() {
  if(document.fullscreenElement) return;
  arrange_elements();
}
